var styles = {"marcomNavgrid":"grid--marcom-navgrid"};

export { styles as default };
//# sourceMappingURL=Grid.module.esm.js.map
